import { SealCheck, LinkSimple, MapPin, Clock, Package } from '@phosphor-icons/react';

export const BlockchainPassport = ({ passport }) => {
  if (!passport) return null;

  const truncateHash = (hash) => {
    if (!hash) return '';
    return `${hash.slice(0, 8)}...${hash.slice(-8)}`;
  };

  return (
    <div className="bg-white border-2 border-dashed border-[#4A6C4C] rounded-xl p-6" data-testid="blockchain-passport">
      {/* Header with Stamp */}
      <div className="flex items-start justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-foreground mb-1">Product Passport</h3>
          <p className="text-sm text-muted-foreground">Blockchain verified authenticity</p>
        </div>
        <div className="blockchain-stamp flex items-center justify-center w-16 h-16 bg-[#4A6C4C]/10">
          <SealCheck weight="duotone" className="w-8 h-8 text-[#4A6C4C]" />
        </div>
      </div>

      {/* Blockchain Hash */}
      <div className="bg-secondary/50 rounded-lg p-4 mb-6">
        <div className="flex items-center gap-2 text-xs text-muted-foreground mb-2">
          <LinkSimple weight="duotone" className="w-4 h-4" />
          <span>Blockchain ID</span>
        </div>
        <code className="text-sm font-mono text-foreground break-all">
          {truncateHash(passport.blockchain_hash)}
        </code>
      </div>

      {/* Artisan Info */}
      {passport.artisan && (
        <div className="border-t border-border pt-4 mb-4">
          <h4 className="text-sm font-medium text-foreground mb-3">Artisan Details</h4>
          <div className="space-y-2 text-sm">
            <div className="flex items-center gap-2 text-muted-foreground">
              <span className="font-medium text-foreground">{passport.artisan.name}</span>
            </div>
            <div className="flex items-center gap-2 text-muted-foreground">
              <MapPin weight="duotone" className="w-4 h-4" />
              <span>{passport.artisan.location}</span>
            </div>
            <div className="flex items-center gap-2 text-muted-foreground">
              <Package weight="duotone" className="w-4 h-4" />
              <span>{passport.artisan.craft_specialty}</span>
            </div>
          </div>
        </div>
      )}

      {/* Origin Info */}
      {passport.origin && (
        <div className="border-t border-border pt-4">
          <h4 className="text-sm font-medium text-foreground mb-3">Product Origin</h4>
          <div className="grid grid-cols-2 gap-3 text-sm">
            <div>
              <span className="text-muted-foreground">Material</span>
              <p className="font-medium">{passport.origin.material}</p>
            </div>
            <div>
              <span className="text-muted-foreground">Source</span>
              <p className="font-medium">{passport.origin.material_origin}</p>
            </div>
            <div>
              <span className="text-muted-foreground">Technique</span>
              <p className="font-medium">{passport.origin.craftsmanship_method}</p>
            </div>
            <div className="flex items-center gap-1">
              <Clock weight="duotone" className="w-4 h-4 text-muted-foreground" />
              <span className="font-medium">{passport.origin.time_spent_hours}h crafting</span>
            </div>
          </div>
        </div>
      )}

      {/* Verification Badge */}
      <div className="mt-6 flex items-center justify-center gap-2 text-[#4A6C4C] text-sm font-medium">
        <SealCheck weight="fill" className="w-5 h-5" />
        <span>Verified on Blockchain</span>
      </div>
    </div>
  );
};

export default BlockchainPassport;
